
import { WordSelectionStrategy } from './WordSelectionStrategy';
import { DailyWordStrategy } from './DailyWordStrategy';
import { PracticeWordStrategy } from './PracticeWordStrategy';

export class WordSelectionStrategyFactory {
  static getStrategy(mode: string): WordSelectionStrategy {
    console.log(`Creating word selection strategy for mode: ${mode}`, {
      timestamp: new Date().toISOString()
    });
    
    // Create new instance based on mode - no caching to avoid cross-contamination
    let strategy: WordSelectionStrategy;
    
    switch (mode.toLowerCase()) {
      case 'practice':
        strategy = new PracticeWordStrategy();
        break;
      case 'daily':
      default:
        strategy = new DailyWordStrategy();
        break;
    }
    
    console.log(`Created word selection strategy for mode: ${mode}`, {
      strategyType: strategy.constructor.name,
      strategyId: strategy.getStrategyId(),
      timestamp: new Date().toISOString()
    });
    
    return strategy;
  }
  
  static resetStrategy(mode: string, forcePlayAgain: boolean = true): void {
    // For practice mode, set the play again flag if explicitly requested
    if (mode === 'practice' && forcePlayAgain) {
      console.log('Setting play again flag for practice mode reset', {
        forcePlayAgain,
        timestamp: new Date().toISOString()
      });
      localStorage.setItem('babblegram_practice_mode_play_again', 'true');
    }
    
    console.log(`Reset requested for mode: ${mode}`, {
      forcePlayAgain,
      timestamp: new Date().toISOString()
    });
  }
}
